import { render, staticRenderFns } from "./card-briefing-entrega.vue?vue&type=template&id=2ace89ed&"
import script from "./card-briefing-entrega.vue?vue&type=script&lang=js&"
export * from "./card-briefing-entrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports